export default "__VITE_ASSET__2c5673b4__"